module.exports = __webpack_public_path__ + "img/18-02.fa0e2971.png";